import { render, staticRenderFns } from "./AlarmPointHistory.vue?vue&type=template&id=1ff31d04&scoped=true"
import script from "./AlarmPointHistory.vue?vue&type=script&lang=ts"
export * from "./AlarmPointHistory.vue?vue&type=script&lang=ts"
import style0 from "./AlarmPointHistory.vue?vue&type=style&index=0&id=1ff31d04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff31d04",
  null
  
)

export default component.exports